import { OrderMapResponseDTO } from 'typings/dto/orderMap';
import Mapper from './Mapper';
import DIContainer from 'services/DIContainer';

export default class OrderMapMapper extends Mapper<OrderMap, OrderMapResponseDTO> {
  constructor(private subEntitiesMappers: DIContainer.SubEntitiesMappers) {
    super({
      number: 'number',
      address: 'address',
      type: 'type',
      visitIntervals: 'visitDateIntervals',
      region: 'region',
    });
  }

  public responseDTOToModel(dto: OrderMapResponseDTO): OrderMap {
    const timezone = dto.region.timezone;
    const type = {
      ...dto.type,
      technicalName: dto.type.technicalName,
      name: dto.type.name,
      logoId: dto.type.logoId,
    };
    const visitDateIntervals = dto.visitIntervals.map((intervalDTO) => {
      const interval: Order.VisitDate = this.subEntitiesMappers.dateInterval.responseDTOToModel(intervalDTO, timezone);
      interval.workEstimateMin = intervalDTO.workEstimation?.durationMinutes;
      interval.completionState = intervalDTO.completionState;
      return interval;
    });
    return {
      ...this.responseDTOToModelViaDiffMap(dto),
      visitDateIntervals,
      type,
      address: dto.address ? this.subEntitiesMappers.address.responseDTOToModel(dto.address) : undefined,
    };
  }
}
